import { TranscriptsApiService, } from '@corti/lib/transcriptsApiService';
export const api = {
    transcripts: undefined,
};
export function initTranscriptsApiService(config) {
    api.transcripts = Object.assign({}, new TranscriptsApiService(config));
}
